export function generateRandomId(length = 20) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const timestamp = Date.now().toString(); // Get the numeric value from Date.now()
  const alphanumericLength = length - timestamp.length; // Calculate space for alphanumeric part

  // Generate the alphanumeric part
  let alphanumericPart = Array.from({length: alphanumericLength}, () => characters[Math.floor(Math.random() * characters.length)]).join("");

  // Combine the alphanumeric part with the timestamp
  let combinedId = alphanumericPart + timestamp;

  // Shuffle the combined string to mix alphanumeric and numeric parts
  let shuffledId = combinedId
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return shuffledId;
}

/**
 * Detects the current device / OS type from the browser user-agent.
 * Returns one of: "macOS" | "Windows" | "Android" | "iOS" | "Linux" | "Unknown"
 */
export function getDeviceType() {
  const ua = navigator.userAgent || "";

  if (/android/i.test(ua)) return "Android";
  if (/iphone|ipad|ipod/i.test(ua)) return "iOS";
  if (/macintosh|mac os x/i.test(ua)) return "macOS";
  if (/win(dows|32|64|CE|Phone)/i.test(ua)) return "Windows";
  if (/linux/i.test(ua)) return "Linux";

  return "Unknown";
}
